import { BaseComponent } from '../../components/base-component'
import { isMobile } from '../../utils/check-media'
import type { TabsComponent } from '../../components/tabs/tabs'
import { CarouselComponent } from 'src/scripts/components/carousel'
import {
  $el,
  $list,
  getFocusTargets,
  whenDefined,
} from 'src/scripts/utils/utils'

const TABS_COMPONENT_SELECTOR = 'tabs-component'
const CAROUSEL_SELECTOR = 'carousel-component'

export class ProductDetails extends BaseComponent {
  isMobile: boolean = isMobile()
  resizeObserver: ResizeObserver

  activeTab: HTMLElement
  activeTabIndex: number
  nextTargetTab: HTMLElement
  lastInnerTarget: HTMLElement

  mountComponent(): void {
    const tabs: TabsComponent = $el(TABS_COMPONENT_SELECTOR, this)

    this.resizeObserver = new ResizeObserver(this.handleResize)
    this.resizeObserver.observe(this)

    whenDefined(TABS_COMPONENT_SELECTOR).then(() => {
      tabs?.on('selectTab', this.handleTabSelect)
    })
  }

  unmountComponent(): void {
    const tabs: TabsComponent = $el(TABS_COMPONENT_SELECTOR, this)

    whenDefined(TABS_COMPONENT_SELECTOR).then(() => {
      tabs?.off('selectTab', this.handleTabSelect)
    })
    this.resizeObserver.disconnect()
  }

  handleTabSelect = ({ tabId, tab }): void => {
    this.activeTab = tab
    this.activeTabIndex = +tabId - 1

    this.scrollToActiveTab()

    const targets = this.getInnerTargets()

    if (targets.length > 0) {
      this.setTabContentTargets(targets)
    }
  }

  handleResize = (): void => {
    if (isMobile() !== this.isMobile) {
      this.isMobile = isMobile()
    }

    if (isMobile()) {
      this.scrollToActiveTab()
    }
  }

  scrollToActiveTab = (): void => {
    const carousel: CarouselComponent = $el(CAROUSEL_SELECTOR, this)
    carousel?.embla.scrollTo(this.activeTabIndex)
  }

  getInnerTargets = () => {
    const targets = $list(getFocusTargets(), this.activeTab)
    return targets
  }

  setTabContentTargets = targets => {
    const tabComponents: TabsComponent = $el(TABS_COMPONENT_SELECTOR, this)
    const tabs = tabComponents.getNames().filter(tab => tab.offsetWidth > 0)

    this.nextTargetTab = tabs[this.activeTabIndex + 1] ?? null
    this.lastInnerTarget = targets[targets.length - 1]

    this.addListener(this.lastInnerTarget, 'blur', this.handleLastTargetBlur)

    targets[0].focus()
  }

  handleLastTargetBlur = () => {
    this.nextTargetTab.focus()

    this.removeListener(this.lastInnerTarget, 'blur', this.handleLastTargetBlur)
    this.lastInnerTarget = null
    this.nextTargetTab = null
  }
}
